import React, { Fragment } from 'react';

const CampoObligatorio = () => {
    return (
        <center>
            <p />
            <span style={{ color: '#FF5733', fontWeight: 'bold' }}>* Estos campos son obligatorios</span>
            <p />
        </center>
    );
};

export default CampoObligatorio;

